<template>
  <BreadCrumb :PageTitle="t('breadCrumb.settingsConfiguration')" />
  <FormValidation />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import FormValidation from "../../components/Settings/ConfigSetting.vue";

export default defineComponent({
  name: "ConfigSettingPage",
  components: {
    BreadCrumb,
    FormValidation,
  },
  setup() {
      const { t } = useI18n();
      return {
      t,
    };
  }
});
</script>